import { userChangeStatus } from '../../redux/features/users/sysAdmin/sysAdminUsersThunk'
import { companyChangeStatus } from '../../redux/features/companies/companiesThunk'

export const companyButtonList = [
  {
    title: 'Active',
    color: '#61CD8C',
    confirmHandler: companyChangeStatus,
    header: 'Activate Company',
    body: 'Are you sure you want to "Activate" this company?',
    finish: 'The company status has been changed to "Active" successfully',
    error: 'Could not change status to Active',
  },
  {
    title: 'Disabled',
    color: '#fc5a5a',
    confirmHandler: companyChangeStatus,
    header: 'Disable Company',
    body: 'Are you sure you want to "Disable" this company.',
    subBody: 'Users assigned to this company will not be able to login.',
    finish: 'The company status has been changed to "Disabled" successfully',
    error: 'Could not change status to Disabled',
    cancelText: 'Cancel',
    confirmText: 'Yes, Disable',
  },
  {
    title: 'Suspended',
    color: '#fc5a5a',
    confirmHandler: companyChangeStatus,
    header: 'Suspend Company',
    body: 'Are you sure you want to "Suspend" this company.',
    subBody: 'Users assigned to this company will not be able to login.',
    finish: 'The company status has been changed to "Suspended" successfully',
    error: 'Could not change status to Suspended',
    cancelText: 'Cancel',
    confirmText: 'Yes, Suspend',
  },
]

export const userButtonList = [
  {
    title: 'Active',
    color: '#61CD8C',
    confirmHandler: userChangeStatus,
    header: 'Activate User',
    body: 'Are you sure you want to "Activate" this user?',
    finish: 'The user status has been changed to "Active" successfully',
    error: 'Could not change status to Active',
  },
  {
    title: 'Disabled',
    color: '#fc5a5a',
    confirmHandler: userChangeStatus,
    header: 'Disable User',
    body: 'Are you sure you want to "Disable" this user.',
    finish: 'The user status has been changed to "Disabled" successfully',
    error: 'Could not change status to Disabled',
    cancelText: 'Cancel',
    confirmText: 'Yes, Disable',
  },
]

export const userActiveStatesList = {
  activate: {
    title: 'Activate user',
    color: '#61CD8C',
    header: 'activate user',
    body: 'Are you sure you want to "Activate user" this user.',
    subBody: 'Are you sure you want to Active this user',
    finish: 'The user status has been "Activated" successfully',
    error: 'Could not "Activate user" this user',
    cancelText: 'Cancel',
    confirmText: 'Yes, Activate user',
  },
  deactivate: {
    title: 'De-activate User',
    color: '#fc5a5a',
    header: 'De-activate User',
    body: 'Are you sure you want to "Deactivate User" this user.',
    subBody:
      'This will prevent the user from doing any assigned role, click yes to proceed the action or cancel the action',
    finish: 'The user status has been "De-activated" successfully',
    error: 'Could not "De-activate User" this user',
    cancelText: 'Cancel',
    confirmText: 'Yes, De-activate User',
  },
}
